app.controller("EmployeeStudentDocumentsController", [
    "$scope", "$stateParams", "StaticData", "DocumentsService", "AuthService", "Students", "$uibModal", "Socket", "$state", "usSpinnerService",
    function ($scope, $stateParams, StaticData, DocumentsService, AuthService, Students, $uibModal, Socket, $state, usSpinnerService) {
        $scope.documents = [];
        $scope.totalItems = 0;
        $scope.itemsPerPage = $stateParams.limit || 10;

        $scope.format = "dd-MM-yyyy";
        $scope.state = $stateParams.state || null;
        $scope.subState = $stateParams.subState || null;
        $scope.query = $stateParams.query || null;
        $scope.type = $stateParams.type || null;
        $scope.parentType = $stateParams.parentType || null;
        $scope.addressee = $stateParams.addressee || null;
        $scope.author = $stateParams.author || null;
        $scope.uniqueNumber = $stateParams.uniqueNumber || null;
        $scope.fromDate = $stateParams.fromDate ? new Date($stateParams.fromDate) : null;
        $scope.toDate = $stateParams.toDate ? new Date($stateParams.toDate) : null;
        $scope.documentTypes = {
            'INNER': {
                active: [],
                deleted: []
            },
            'STUDENT_INNER': {
                active: [],
                deleted: []
            },
        };

        $scope.states = [
            { name: 'განხილული', _id: 'reviewed' },
            { name: 'განსახილველი', _id: 'new' },
            { name: 'მობრუნებული', _id: 'returned' },
            { name: 'მიმდინარე', _id: 'current' },
            { name: 'შესრულებული', _id: 'done' }
        ];

        $scope.subStates = [
            { name: 'წარმატებით', _id: 'done' },
            { name: 'წარუმატებლად', _id: 'returned' }
        ];

        $scope.popup1 = {
            opened: false
        };

        $scope.popup2 = {
            opened: false
        };

        $scope.fromDateOptions = {
            maxDate: new Date()
        };

        $scope.openFromDate = function () {
            $scope.popup1.opened = true;
        };

        $scope.openToDate = function () {
            $scope.popup2.opened = true;
        };

        if ($stateParams.addressee) {
            DocumentsService.getEmployee($stateParams.addressee).then(function (emp) {
                $scope.addressee = emp;
            });
        }

        if ($stateParams.author) {
            Students.listEmployee({ _id: $stateParams.author }).then(function (res) {
                $scope.author = res.docs[0];
            });
        }

        $scope.getStudents = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Students.listEmployee({ query: query }).then(function (data) {
                return data.docs;
            });
        };

        var socket = new Socket("/documents");

        socket.on('reviewed', function (document) {
            $scope.documents.unshift(document);
            $scope.totalItems = $scope.documents.length;
        });

        DocumentsService.typeList({ admin: true }).then(function (data) {
            data.forEach(function (type) {
                if (type.isForStudent) {
                    if (type.status) $scope.documentTypes[type.parentId].active.push(type)
                    else $scope.documentTypes[type.parentId].deleted.push(type)
                }

            });
            $scope.type = $stateParams.type || null;
        }).catch(function () {
            usSpinnerService.spin("root");
            toastr.error('', 'დაფიქსირდა შეცდომა');
        });

        $scope.applyFilter = function () {
            $state.go(".", {
                page: $scope.currentPage,
                limit: $scope.itemsPerPage,
                query: $scope.query,
                type: $scope.type,
                parentType: $scope.parentType,
                state: $scope.state,
                subState: $scope.subState,
                fromDate: $scope.fromDate,
                toDate: $scope.toDate,
                uniqueNumber: $scope.uniqueNumber,
                author: $scope.author && $scope.author._id ? $scope.author._id : $scope.author,
                addressee: $scope.addressee && $scope.addressee._id ? $scope.addressee._id : $scope.addressee
            });
        };

        $scope.changePage = function () {
            $state.go(".", { page: $scope.currentPage });
        };

        loadPage($stateParams.page).then(function () {
            $scope.currentPage = $stateParams.page;
        });

        function loadPage(page) {
            usSpinnerService.spin("root");
            return DocumentsService.documentsFromStudents({
                page: page || 1,
                limit: $scope.itemsPerPage,
                query: $scope.query,
                state: $scope.state,
                subState: $scope.subState,
                type: $scope.type,
                parentType: $scope.parentType,
                fromDate: $scope.fromDate,
                toDate: $scope.toDate,
                uniqueNumber: $scope.uniqueNumber,
                author: $scope.author && $scope.author._id ? $scope.author._id : $scope.author
            }).then(function (res) {
                $scope.documents = res.data.docs;
                $scope.totalItems = res.data.total;
                $scope.itemsPerPage = res.data.limit;
                usSpinnerService.stop("root");
            });
        }

        $scope.open = function (actionType, docId, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            $state.go('employee.documents.view', { actionType: actionType, documentId: docId, returnUrl: window.location.href })
        };

        $scope.showComment = function (comment, $event) {
            if ($event) {
                $event.stopPropagation();
            }

            $uibModal.open({
                controller: "CommentWindowController",
                templateUrl: _pb + 'employee/documents/comment-window.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            comment,
                            action: 'view',
                            header: 'კანცელარიის'
                        };
                    }
                }
            })
        };

        $scope.generateTooltip = function (doc) {
            var status = doc.status;
            if (!doc.status) doc.status = null;
            if (doc.chancelleryStatus === 'returned') {
                status = 'returned'
            }

            var stepMap = {
                'null': 'მიმდინარე',
                'unread': 'წაუკითხავი',
                'returned': 'მობრუნებული',
                'approved': 'დაშვებული',
                'done': 'შესრულებული',
            };
            return stepMap[status];
        };

        $scope.generateClass = function (doc) {
            var status = doc.status;
            if (doc.chancelleryStatus === 'returned') {
                status = 'returned'
            }
            if (doc.chancelleryStatus === 'approved' && !status) return 'doc-read'
            if (!status || status === 'unread') return 'doc-unread';
            if (status === 'approved') return 'doc-approved';
            if (status === 'read') return 'doc-read';
            if (status === 'done') return 'doc-done';
            if (status === 'returned') return 'doc-returned';
        };

        $scope.menu = function ($event) {
            if ($event) {
                $event.stopPropagation();
            }
        };

        $scope.download = function (url, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            window.open(url);
        };

        $scope.finalize = function (document, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "FinalizeReviewedModalController",
                templateUrl: _pb + 'employee/documents/finalize-reviewed-modal.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            documents: [document],
                            isForStudent: document.isForStudent
                        };
                    }
                }
            }).result
                .then(function () {
                    loadPage($stateParams.page).then(function () {
                        $scope.currentPage = $stateParams.page;
                    });
                }, function () {
                });
        };

        $scope.add = function () {
            $state.go('employee.documents.new-student');
        };
    }
]);
